export default "__VITE_ASSET__B1UnTVc7__"